import { Routes } from '@angular/router';
import {NotFoundComponent} from "./components/pages/not-found/not-found.component";
import {AdminGuard} from "./guard/admin.guard";

import { SignInComponent } from './components/pages/sign-in/sign-in.component';

import { HomeComponent } from './components/pages/home/home.component';
import { SliderComponent } from './components/pages/slider/slider.component';
import { MarksComponent } from './components/pages/marks/marks.component';
import { CarsComponent } from './components/pages/cars/cars.component';
import { PartsComponent } from './components/pages/parts/parts.component';
import { NewsComponent } from './components/pages/news/news.component';
import { OrdersComponent } from './components/pages/orders/orders.component';

export const routes: Routes = [

  {path: '', component: HomeComponent, canActivate: [AdminGuard]},
  {path: 'marks', component: MarksComponent, canActivate: [AdminGuard], data: { permission: 'marks' }},
  {path: 'cars', component: CarsComponent, canActivate: [AdminGuard], data: { permission: 'cars' }},
  {path: 'parts', component: PartsComponent, canActivate: [AdminGuard], data: { permission: 'parts' }},
  {path: 'news', component: NewsComponent, canActivate: [AdminGuard], data: { permission: 'news' }},
  {path: 'slider', component: SliderComponent, canActivate: [AdminGuard], data: { permission: 'slider' } },
  {path: 'orders', component: OrdersComponent, canActivate: [AdminGuard], data: { permission: 'orders' } },
  {path: 'login', component: SignInComponent},
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: '/not-found' }

];